import React from 'react'
import Helmet from 'react-helmet'
import { Box } from 'grid-styled'
import { connect } from 'react-redux'
import { fetchReasonList, fetchGetBusinessUser, fetchLogout } from 'alelo-logic/actions'
import { withRouter } from 'react-router-dom'

import ImersiveHeader from '../../elements/ImersiveHeader'
import BlockIdentifiersForm from '../../modules/BlockIdentifiersForm'
import { setLoading } from '../../modules/PageLoader/actions'

import { showModal } from '../../modules/ModalRoot/actions'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'
import imageError from '../../../static/contestacao.png'

import { Content, Heading, Subtitle, Paragraph, Wrapper } from './styles'

import { helmetTitle, title, text, optionsSubtitle } from './data.json'

class BlockIdentifiers extends React.Component {
  state = {
    reasonList: [],
    reasonSelected: ''
  }

  async componentDidMount() {
    const {
      dispatch,
      setLoading,
      history,
      getUser,
      user,
      reasonListBlock,
      match: { params: { id } }
    } = this.props
    const idAccount = id

    if (user && user.enderecos && user.enderecos.length > 0 && reasonListBlock) {
      this.setState({ reasonList: reasonListBlock })
    } else {
      setLoading(true)
      await getUser(history)
        .then(resp => {
          this.setState({ reasonList: (resp && resp[1]) || [] })
        })
        .catch(resp => {
          if (resp && (resp.status === 401 || resp.status === 403)) {
            dispatch(fetchLogout())
            history.push('/conta/login')
          } else {
            dispatch(
              showModal(CONFIRM_UPDATE, {
                modalTitle: 'Ops! Seus dados estão incompletos',
                modalDescription:
                  'Não foi possível seguir com sua solicitação. Atualize seus dados cadastrais no menu empresarial e caso o erro persista, entre em contato com a gente.',
                image: imageError
              })
            )
            history.push(`/minha-veloe/${idAccount}/identificadores`)
            // history.back()
          }
        })
        .finally(() => setLoading(false))
    }
  }

  // componentDidUpdate = (prevProps, prevState) => {
  //   const { shoModalErro, profile } = this.props
  //   console.log('prevProps -> ', prevProps)
  //   console.log('prevState <-', prevState)
  //   console.log('profile -> ', profile)

  //   if (!prevState.profile) {
  //     shoModalErro(CONFIRM_UPDATE, {
  //       modalTitle:
  //         '2222Problema ao buscar dados da conta, caso persista entre em contato com o suporte.',
  //       image: imageError
  //     })
  //   }
  // }

  handleSave = (values, history) => {
    const idAccount = this.props.match.params.id
    const identifier = this.props.match.params.identifierId
    history.push(
      `/minha-veloe/${idAccount}/identificador/${identifier}/bloquear/novo-identificador/?option=${
        values.option
      }${values.descricaoOutroProblema ? `&description=${values.descricaoOutroProblema}` : ''}`
    )
  }

  handleChangeReason = value => this.setState(() => ({ reasonSelected: value }))

  render() {
    const { history } = this.props
    const { reasonList, reasonSelected } = this.state
    return (
      <section>
        <ImersiveHeader text="Minhas Veloetags" back={history.goBack} />
        <Content>
          <Box width={[1, 6 / 12]}>
            <Helmet title={helmetTitle} />
            <Heading>{title}</Heading>
            <section>
              <Paragraph>{text}</Paragraph>
            </section>
            <section>
              <Subtitle>{optionsSubtitle}</Subtitle>
              <Wrapper>
                <BlockIdentifiersForm
                  onSubmit={values => this.handleSave(values, history)}
                  reasonList={reasonList}
                  reasonSelected={reasonSelected}
                  handleChangeReason={this.handleChangeReason}
                />
              </Wrapper>
            </section>
          </Box>
        </Content>
      </section>
    )
  }
}

export const mapStateToProps = ({ form, reducer }) => ({
  form,
  account: reducer.account,
  user: reducer.user,
  reasonListBlock: reducer.reasonsListBlock.reasons
})

export const mapDispatchToProps = dispatch => ({
  dispatch,
  getUser: history => {
    return Promise.all([dispatch(fetchGetBusinessUser()), dispatch(fetchReasonList())])
  },
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  shoModalErro: (imagem, infos) => dispatch(showModal(imagem, infos))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BlockIdentifiers))



// WEBPACK FOOTER //
// ./src/app/pages/BlockIdentifiers/index.js